import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import { clearAuth, parseJwt, verifyAuth } from "@/helpers";
import axios from 'axios';

Vue.use(Vuex);

export interface Auth {
	givenname: string;
	surname: string;
	fullname: string;
	hetu: string;
	dob: string;
}

export default new Vuex.Store({
  state: {
		strongAuth: null as Auth | null,
		jwt: null as string | null,
		org: null as string | null,
		lang: '' as string,
		orgServices: [] as string[],
		isMobile: false as boolean,
		showMobileMenu: false as boolean
	},
	mutations: {
		setAuth(state, payload: { authObject: Auth; jwt: string }) {
			state.strongAuth = payload.authObject;
			state.jwt = payload.jwt;
		},
		setOrgLang(state, payload: { org: string; lang: string }) {
			state.org = payload.org;
			state.lang = payload.lang;
			localStorage.setItem("org", payload.org);
			localStorage.setItem("lang", payload.lang);
		},
		changelang(state, payload: { lang: string }) {
			state.lang = payload.lang;
		},
		setMobile(state, payload :number) {
			payload < 576 ? state.isMobile = true : state.isMobile = false;
		},
		setMobileMenu(state, show : boolean) {
			state.showMobileMenu = show;
		},
		setAvailableServices(state, payload: { orgServices: string[] }) {
			state.orgServices = payload.orgServices;
			if (payload.orgServices == null) {
				localStorage.removeItem("orgServices")
			}
			else {
				const serviceString = payload.orgServices.join();
				localStorage.setItem("orgServices", serviceString);
			}
		}
	},
	getters: {
		isMobile: state => {
			return state.isMobile;
		}
	},
	actions: {
		async auth(ctx, authKey: string) {
			// if user has reloaded the auth redirect page with authKey, we check auth with jwt
			const jwt = Cookies.get("jwt");
			if (jwt) {
				await verifyAuth(this, jwt);
				return;
			}

			try {
				if (axios.defaults.headers.jwt) {
					delete axios.defaults.headers.jwt;
				}

				const resp = await axios.get("auth/data/" + authKey);

				if (resp && resp.data) {
					Cookies.set("jwt", resp.data.jwt, { expires: 1 });
					await verifyAuth(this, resp.data.jwt);
				}
			} catch (error) {
				clearAuth(this);
			}
		},

		async authJwt(ctx, jwt) {
			Cookies.set("jwt", jwt, { expires: 1 });
			await verifyAuth(this, jwt);
		}
	},
	modules: {}
});
